/**
 * File: UserCard.js
 * Origin: isotect
 * Description: UserCard component that renders a user information card.
 *
 * Version: v1.0.0
 * Created: 2026-04-22
 * Last Updated: 2026-04-23
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * UserCard component that renders a user information card.
 *
 * @component
 *
 * @param {Object} props - Component properties
 * @param {React.ComponentType} props.icon - Icon component to render
 * @param {string} props.name - User name
 * @param {string} props.text - Informational text to display
 * @param {boolean} props.isDetails - Whether to display user details
 * @param {number} [props.size] - Icon size in pixels
 *
 * @returns {JSX.Element} Rendered user card component
 */
function UserCard({ icon: Icon, name, text, isDetails, size = 24 }) {
    return (
        <>
            <div className="user-card">
                <Icon size={size} />
                {isDetails ? (
                    <div className="user-card__container">
                        <p className="user-card__name">{name}</p>
                        <p className="user-card__text">{text}</p>
                    </div>
                ) : null}
            </div>
        </>
    );
}

export default UserCard;
